import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectAgreementLink } from '../../selectors/agreementLink';
import { Link } from '../Link';

interface IProps {
  onClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const AgreementLine = (props: IProps) => {
  const { onClick } = props;

  const agreement = useSelector(selectAgreementLink);

  if (!agreement) {
    return null;
  }

  const { displayText, linkText, linkUrl } = agreement;

  return (
    <>
      {displayText}{' '}
      <Link href={linkUrl} underlined onClick={onClick} testId="EULA">
        {linkText}
      </Link>
      {'. '}
    </>
  );
};
